"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var spanish_custom_labels_1 = __importDefault(require("./spanish-custom-labels"));
var questionConfig = function (apiUrl, doolittleBaseMediaUrl, noFastForward, minimumVideoQuality, shouldAutoRead, shouldAutoPlay) { return ({
    apiPath: apiUrl,
    completionRequired: true,
    hideSubmit: false,
    answerCorrectnessCues: {
        audioPositivePath: "".concat(doolittleBaseMediaUrl, "/static/assets/correct.mp3"),
        audioNegativePath: "".concat(doolittleBaseMediaUrl, "/static/assets/incorrect.mp3"),
        showIconDuration: 1600,
        iconsEnabled: true
    },
    feedback: {
        display: "spotlight",
        required: true,
        disableFastForward: noFastForward,
        autoPlay: true,
        minimumQuality: minimumVideoQuality,
        offScreenCaptioning: true,
        type: {
            Audio: {
                display: "below"
            }
        }
    },
    readAloud: {
        on: true,
        autoRead: shouldAutoRead && shouldAutoPlay,
        easyClick: {
            clozeassociation: {
                selectors: [".lrn_draggable"]
            },
            mcq: {
                selectors: [".lrn-mcq-option .lrn-label"]
            },
            imageclozeassociationV2: {
                selectors: [".lrn_draggable"]
            },
            classification: {
                selectors: [".lrn_draggable", ".lrn_column_title"]
            },
            association: {
                selectors: [".lrn_assoc_row .lrn_assoc_question"]
            }
        }
    }
}); };
var readerConfig = function (debugMode, apiUrl, disableAnnotations, isSpanishContent, richTextType, doolittleBaseMediaUrl, noFastForward, minimumVideoQuality, shouldAutoRead, shouldAutoPlay, isAudioCompletionRequired, dictionaryType, itemEngineAuthorUri, itemEngineItemsUri, speechStreamEnabled, mathJax) { return ({
    debug: debugMode,
    featureFlags: {
        apiPath: "https://content.app.edgenuity.com/api/flags/api/v1"
    },
    numbering: true,
    showHeader: false,
    takeEventsEnabled: true,
    tailpipeUrl: "".concat(apiUrl, "/events"),
    display: {
        pathLabel: "Activity",
        segmentLabel: "Page"
    },
    progressFooter: {
        show: false,
        btnLabel: "Continue",
        disableDefaultAction: false
    },
    navigation: {
        pageIndexArrows: false,
        arrows: false
    },
    annotations: {
        disabled: disableAnnotations,
        readonly: true,
        hideSidebarWhenEmpty: true
    },
    panels: {
        disabled: false,
        contentOptions: ["RichText", "Image", "Video", "Audio", "Instruction"]
    },
    passages: {
        disabled: false
    },
    heartbeat: {
        isEnabled: true,
        interval: 30000,
        timeToIdle: 1200000
    },
    labeling: {
        aliasDisplay: "Alias",
        aliasOptions: ["Production", "QA", "Staging"]
    },
    labelBundles: isSpanishContent ? spanish_custom_labels_1.default : null,
    tagging: {
        types: ["word-count", "lexile"]
    },
    contentOptions: [
        richTextType,
        "IframeInteractive",
        "Image",
        "Video",
        "Audio",
        "Question",
        "Instruction",
        "LinkedLearningPath"
    ],
    contentComponents: {
        IframeInteractive: {
            launchUrlBase: "https://media.edgenuity.com/contentengine/common",
            exploratory: true,
            completionRequired: true
        },
        Image: {
            apiPath: apiUrl,
            enableClickEvent: true
        },
        Question: questionConfig(apiUrl, doolittleBaseMediaUrl, noFastForward, minimumVideoQuality, shouldAutoRead, shouldAutoPlay),
        TwigItem: {
            apiPath: apiUrl,
            itemEngineAuthorUri: itemEngineAuthorUri,
            itemEngineItemsUri: itemEngineItemsUri
        },
        QuestionItem: questionConfig(apiUrl, doolittleBaseMediaUrl, noFastForward, minimumVideoQuality, shouldAutoRead, shouldAutoPlay),
        Video: {
            apiPath: apiUrl,
            autoPlay: shouldAutoPlay,
            completionRequired: true,
            disableFastForward: noFastForward,
            showTranscriptOnRight: true,
            minimumQuality: minimumVideoQuality,
            captioning: {
                offScreen: true
            }
        },
        Audio: {
            apiPath: apiUrl,
            // In the MPNG Educator app, "completionRequired" must always evaluate to false.
            // In the MPNG Content Preview app, "completionRequired" must always evaluate to false.
            // In the MPNG Student app, "completionRequired" evaluates to true.
            completionRequired: isAudioCompletionRequired,
            autoPlay: shouldAutoRead && shouldAutoPlay
        },
        LinkedLearningPath: {
            apiPath: apiUrl
        },
        RichText: {
            tools: [
                "BOLD",
                "ITALIC",
                "UNDERLINE",
                "H2",
                "H3",
                "H4",
                "UL",
                "OL",
                "INDENT",
                "UNINDENT",
                "ALIGN",
                "LINK",
                "VOCABULARY",
                "CLEAR"
            ]
        }
    },
    dictionary: {
        id: dictionaryType,
        logoUrl: "https://dictionaryapi.com/images/info/branding-guidelines/MWLogo_DarkBG_120x120_2x.png"
    },
    organization: "Imagine Learning",
    tools: {
        translation: {
            enabled: true,
            language: "en"
        },
        textToSpeech: {
            enabled: false,
            language: "en",
            voiceName: "",
            voiceSpeed: ""
        }
    }
}); };
exports.default = readerConfig;
